import { jsx as r } from "react/jsx-runtime";
import "react";
import { ImageReplacementAnchor as o } from "../ImageReplacementAnchor/ImageReplacementAnchor.js";
import '../../assets/LogoNavigation.css';function l({ items: n = [], height: e = 4 }) {
  return /* @__PURE__ */ r("logo-navigation", { style: {
    "--logo-nav-max-height": `${e}rem`
  }, children: n.length > 0 && n.map((a) => /* @__PURE__ */ r(
    o,
    {
      href: a.href,
      target: (a == null ? void 0 : a.target) ?? "_self",
      image: a.image,
      height: a.height,
      baselineAdjustment: a != null && a.baselineAdjustment ? a.baselineAdjustment : 0,
      text: a.text
    },
    `ira-${Math.round(Math.random() * 1e7)}`
  )) });
}
export {
  l as LogoNavigation,
  l as default
};
